import platformAdminApiClient, { setPlatformAdminToken } from './platformAdminApiClient';

export async function bootstrap(fullName, email, password) {
  const res = await platformAdminApiClient.post('/platform-admin/auth/bootstrap', { fullName, email, password });
  return res.data.data;
}

export async function login(email, password) {
  const res = await platformAdminApiClient.post('/platform-admin/auth/login', { email, password });
  setPlatformAdminToken(res.data.data.accessToken);
  return res.data.data.admin;
}

export function logout() {
  setPlatformAdminToken(null);
}

export async function listCompanies() {
  const res = await platformAdminApiClient.get('/platform-admin/companies');
  return res.data.data.items;
}

export async function createCompany(payload) {
  const res = await platformAdminApiClient.post('/platform-admin/companies', payload);
  return res.data.data;
}

export async function updateLicense(companyId, payload) {
  const res = await platformAdminApiClient.patch(`/platform-admin/companies/${companyId}/license`, payload);
  return res.data.data.company;
}

export async function suspendCompany(companyId) {
  const res = await platformAdminApiClient.post(`/platform-admin/companies/${companyId}/suspend`);
  return res.data.data.company;
}

export async function activateCompany(companyId) {
  const res = await platformAdminApiClient.post(`/platform-admin/companies/${companyId}/activate`);
  return res.data.data.company;
}
